

















































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import VueApexCharts from "vue-apexcharts";
import {
	TitleTemplatePublic,
	RedCapital,
	SelectedCountry,
	RedCapitalConfig
} from "@/configuration";
import ProjectCard from "@/components/ProjectCardHome.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";
import NumbersPanel from "@/components/homeView/NumbersPanel.vue";
import CardWeDo from "@/components/CardItem.vue";
import ISO from "@/components/ISO/ISO.vue";
import { mapState } from "vuex";
import API from "@/api";
import ServicesCarousel from '../components/ServicesCarousel.vue';
import HomeWarren from "@/components/HomeWarren.vue";
import NoInvertirFacturas from "@/components/NoInvertirFacturas.vue";
import ProjectCardToken from '@/components/ProjectCardToken.vue'

@Component({
	metaInfo: {
		title: "RedCapital  | Plataforma de Financiamiento Digital ",
		//titleTemplate: TitleTemplatePublic,
		htmlAttrs: {
			// @ts-ignore
			lang: RedCapital[SelectedCountry].Lang
		}
	},
	computed: {
		...mapState(["user", "amountFinanced"]),
		projectsVisibility() {
			return (
				this.$store.state.user != null ||
				RedCapitalConfig(SelectedCountry).Project.PublicVisibility
			);
		}
	},
	data() {
		return {
			RedCapital,
			SelectedCountry,
			navigationNext: `<i class="material-icons primary--text">arrow_forward_ios</i>`,
			navigationPrevious: `<i class="material-icons primary--text">arrow_back_ios</i>`,
			pressData: [{
				alt: "Pulso",
				image: "/images/pulso-logo.png"
				},{
				alt: "El Mercurio",
				image: "/images/mercurio-logo.png"
				},{
				alt: "EMOL",
				image: "/images/emol-logo.png"
				},{
				alt: "CNN Chile",
				image: "/images/cnn-logo.png"
				},{
				alt: "Diario Financiero",
				image: "/images/df-logo.png"
				},
				/* {
				alt: "Aldamir",
				image: "/images/aldamir-logo.png"
				}, */
				{
				alt: "Forbes",
				image: "/images/forbes-logo.png"
				},{
				alt: "Las Últimas Noticias",
				image: "/images/lun-logo.png"
				},{
				alt: "Capital",
				image: "/images/capital-logo.png"
				},{
				alt: "NewNexus",
				image: "/images/nexnews-logo.png"
			}],
			whatDoWeDoInfo: [
				
			],
			projects: null,
			options: {
				projects: {
					perPage: 4
				},
				press: {
					perPage: 4
				}
			},
			amounts: {
				financed: '000',
				pymes: '0000',
				renta: '00.0',
				lastThirtyDays: 0,
				render: {
					financed: 0,
					pymes: 0,
					renta: 0,
					lastThirtyDays: 0
				}
			},
			/* Datos Grafico */
			graphData: {
				fechasPago:{
					series: [{
						name: "Facturas",
						data: [60.4, 21.4, 9.2, 6.8, 0.7, 0.5, 0.9]	
					},{
						name: "Créditos",
						data: [43.4, 11.3, 17, 13.5, 6.6, 7.8, 0.3]
					}],
					chartOptions: {
						chart: {
							height: 350,
							type: 'area',
							toolbar: {
								show: false
							},
							zoom: {
								enabled: false
							}
						},
						legend: {
							position: 'bottom',
							fontSize: '14px',
							fontFamily: '"SF Pro Text"',
							onItemClick: {
								toggleDataSeries: false
							},
							onItemHover: {
								highlightDataSeries: false
							},
							itemMargin: {
								horizontal: 20,
								vertical: 40
							},
						},
						markers:{
							size: 0
						},
						colors: ['#fd773f', '#00d1a8'],
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'smooth'
						},
						grid: {
							yaxis: {
								lines: {
									show: false
								}
							}
						},
						yaxis: {
							forceNiceScale: true,
							decimalsInFloat: 0,
							tickAmount: 4,
							max: 60,
							labels: {
								style: {
									fontFamily: '"SF Pro Text"',
									fontWeight: '500',
									fontSize: '12px',
									colors: '#8b8b8b'
								},
								// @ts-ignore
								formatter: function (val) {
									return val + " %"
								}
							},
							title: {
								text: 'Porcentaje',
								style: {
									fontFamily: '"SF Pro Text"',
									fontWeight: '500',
									fontSize: '16px',
									colors: '#3d3d3d'
								}
							}
						},
						xaxis: {
							categories: ['<=0', '1 - 15', '16 - 30', '31 - 60', '61 - 90', '91 - 180', '>180'],
							labels: {
								style: {
									fontFamily: '"SF Pro Text"',
									fontWeight: '500',
									fontSize: '12px',
									colors: '#8b8b8b'
								}
							},
							title: {
								text: 'Días',
								style: {
									fontFamily: '"SF Pro Text"',
									fontWeight: '500',
									fontSize: '16px',
									colors: '#3d3d3d'
								}
							},
						},
						tooltip: {
							y: {
								// @ts-ignore
								formatter: function (val) {
									return val + " %"
								}
							}
						}
					}
				},
				rentabilidad:{
					series: [{
						name: 'Fondos Mutuos',
						data: [4, 1]
					},{
						name: '% RedCapital',
						data: [this.$store.state.amountRenta, 7.3]
					}],
					chartOptions: {
						chart: {
							type: 'bar',
							toolbar: {
								show: false
							}
						},
						plotOptions: {
							bar: {
								horizontal: false,
								columnWidth: '80%',
								borderRadius: 18,
								endingShape: 'rounded',
								dataLabels:{
									position: 'top'
								}
							}
						},
						colors: ["#00d1a8", "#fd773f"],
						legend: {
							position: 'bottom',
							fontSize: '14px',
							fontFamily: '"SF Pro Text"',
							fontWeight: '500',
							onItemClick: {
								toggleDataSeries: false
							},
							onItemHover: {
								highlightDataSeries: false
							},
							markers: {
								width: 16,
								height: 16,
								radius: 12,
							},
							itemMargin: {
								vertical: 40
							},
						},
						dataLabels: {
							// @ts-ignore
							formatter: function (val) {
								return val + " %"
							},
							style: {
								fontSize: '16px',
								fontFamily: '"SF Pro Text"',
								fontWeight: '500',
								colors: ['#3d3d3d','#3d3d3d']
							},
							offsetY: -30
						},
						stroke: {
							show: true,
							width: 20,
							colors: ['transparent']
						},
						grid: {
							yaxis: {
								lines: {
									show: false
								}
							}
						},
						xaxis: {
							categories: ['Nominal', 'Real'],
							labels: {
								style: {
									fontSize: '18px',
									fontFamily: '"SF Pro Text"',
									fontWeight: '500',
									colors: '#3d3d3d'
								},
								offsetY: 14,
							},
						},
						yaxis: {
							show: false
						},
						fill: {
							colors: ['#00d1a8', '#fd773f'],
							type: "gradient",
							gradient: {
								type: "diagonal1",
								gradientToColors: ['#5AFEDE', '#ff8a00'],
								shadeIntensity: 0.8,
								opacityFrom: 0.9,
								opacityTo: 1,
								stops: [0, 100],
								inverseColors: false,
								
							}
						},
						tooltip: {
							//fillSeriesColor: true,
							shared: true,
							intersect: false,
							y: {
								// @ts-ignore
								formatter: function (val) {
									return val + " %"
								}
							}
						}
					}
				}
			},
			/* Video */
			videosRc:{
				video1:{
					data: '{"techOrder": ["youtube"], "sources": [{ "type": "video/youtube", "src": "https://www.youtube.com/watch?v=2wpIcpoUqOo"}]}'
				},
				video2:{
					autoplay: false,
					controls: true,
					fluid: true,
					preload: 'auto',
					sources: [
						{
							src: "/images/videos/RedcaCNN.mp4",
							type: "video/mp4"
						}
					],
					controlBar: {
						'liveDisplay': true,
						'pictureInPictureToggle': false,
						'fullScreenToggle': false
					}
				}
			},
			ejecutarAnimacion : false,
			montosApi: null,
		};
	},
	watch: {
		user() {
			// @ts-ignore
			this.obtainProjects();
		}
	},
	async beforeMount() {
		// @ts-ignore
		this.obtainProjects();

		this.$data.whatDoWeDoInfo = await API.queHacemos();
	},
	async mounted() {
		this.$data.montosApi = await API.getAmounts();
		if (this.$data.montosApi.principal != null) {
			let dataHome = {
				amountFinanced : parseInt(this.$data.montosApi.principal),
				amountPymes : parseInt(this.$data.montosApi.pymes),
				amountRenta : parseFloat(this.$data.montosApi.rentabilidad)
			};
			this.$store.commit("setAmountDataHome", dataHome);
			this.$data.amounts.financed = parseInt(this.$data.montosApi.principal);
			this.$data.amounts.pymes = parseInt(this.$data.montosApi.pymes);
			this.$data.amounts.renta = parseFloat(this.$data.montosApi.rentabilidad);
		}else{
			this.$data.amounts.financed = this.$store.state.amountFinanced;
			this.$data.amounts.pymes = this.$store.state.amountPymes;
			this.$data.amounts.renta = this.$store.state.amountRenta;
		}
		this.$data.amounts.lastThirtyDays = parseInt(this.$data.montosApi.secundario);
		
		setTimeout(()=>{
			this.$data.ejecutarAnimacion = true;
		},1000);
		// @ts-ignore
		this.onResponsive();
		// @ts-ignore
		window.addEventListener("resize", this.onResponsive);
		// @ts-ignore
		setInterval(()=>{this.efectoTitulo()}, 6000);
	},
	beforeDestroy() {
		// @ts-ignore
		window.removeEventListener("resize", this.onResponsive);
	},
	methods: {
		onResponsive() {
			let w = window.innerWidth;
			if (w < 600) {
				this.$data.options.projects.perPage = 1;
				this.$data.options.press.perPage = 2;
			} else if (w > 600 && w < 960) {
				this.$data.options.projects.perPage = 2;
				this.$data.options.press.perPage = 3;
			} else if (w > 960 && w < 1264) {
				this.$data.options.projects.perPage = 3;
				this.$data.options.press.perPage = 4;
			} else if (w > 1264 && w < 1904) {
				this.$data.options.projects.perPage = 3;
				this.$data.options.press.perPage = 5;
			} else if (w > 1904) {
				this.$data.options.projects.perPage = 4;
				this.$data.options.press.perPage = 8;
			}
		},
		obtainProjects() {
			// @ts-ignore
			if (this.projectsVisibility) {
				API.getProjects({
					factura: 1,
					credito: 1,
					tasa: 3,
					cuota: 24,
					offset: 0
				}).then((projects: any) => {
					this.$data.projects =
					projects.length < 12
					? projects.slice(0, projects.length)
					: projects.slice(0, 12);
					
					let i:any = [], j:any = []
					
					this.$data.projects.forEach((element:any) => {
						element.native_porcentaje_invertido < 99 ?
						i.push(element)
						: j.push(element)
					})

					i.sort((a:any,b:any)=>{
						if(a.monto_disponible < b.monto_disponible){
							return 1
						}else{
							return -1
						}
					})

					this.$data.projects= i.concat(j)
				});
			}
		},
		fadeInText(el, texto, time) {
			el.innerHTML = texto;
			el.style.opacity = 0;
			var last = +new Date();
			var tick = function() {
				// @ts-ignore
				el.style.opacity = +el.style.opacity + (new Date() - last) / time;
				last = +new Date();
				if (+el.style.opacity < 1) {
				// @ts-ignore
				(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
				}
			};
			tick();
		},
		efectoTitulo(){
			// @ts-ignore
			if(document.getElementById('rc-cambioTexto').innerHTML == 'Invertir'){
				// @ts-ignore
				this.fadeInText(document.getElementById('rc-cambioTexto'), 'Financiarte', 3000);
			}else{
				// @ts-ignore
				this.fadeInText(document.getElementById('rc-cambioTexto'), 'Invertir', 3000);
			}
		}
	},
	components: {
		ProjectCard,
		VideoPlayer,
		NumbersPanel,
		CardWeDo,
		graphRentabilidad : VueApexCharts,
		graphFechasPago : VueApexCharts,
		ISO,
		ServicesCarousel,
		HomeWarren,
		NoInvertirFacturas,
		ProjectCardToken
	}
})
export default class HomeNew extends Vue{}
